import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCouponButtonIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 26,
	height: 22,
	viewBox: "0 0 26 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.33325 6.33317V5.1665M8.33325 11.5832V10.4165M8.33325 16.8332V15.6665M6.93325 20.3332H19.0666C21.0268 20.3332 22.0069 20.3332 22.7556 19.9517C23.4141 19.6161 23.9496 19.0807 24.2851 18.4221C24.6666 17.6734 24.6666 16.6934 24.6666 14.7332V7.2665C24.6666 5.30632 24.6666 4.32623 24.2851 3.57754C23.9496 2.91897 23.4141 2.38354 22.7556 2.04798C22.0069 1.6665 21.0268 1.6665 19.0666 1.6665H6.93325C4.97307 1.6665 3.99298 1.6665 3.24429 2.04798C2.58572 2.38354 2.05029 2.91897 1.71473 3.57754C1.33325 4.32623 1.33325 5.30632 1.33325 7.2665V14.7332C1.33325 16.6934 1.33325 17.6734 1.71473 18.4221C2.05029 19.0807 2.58572 19.6161 3.24429 19.9517C3.99298 20.3332 4.97307 20.3332 6.93325 20.3332Z",
		stroke: "#1DC483",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCouponButtonIcon;
